import noop from 'lodash/noop';

const swapToWebp = (url: string): string => url.replace(/.gif|.jpg|.jpeg|.png/, '.webp');

export const transformUrl = (url: string, webp: boolean) => {
  if (!url) {
    return url;
  }
  const { protocol } = __CLIENT__ ? window.location : { protocol: 'https:' };
  const finalUrl = !url.includes(protocol) ? url.replace('http:', protocol) : url;
  return webp ? swapToWebp(finalUrl) : finalUrl;
};

// TODO: Should probably bubble this up as an exception and catch it at a centralized
// error logging class (to track on the server) later on
export const trackImgErr =
  process.env.DEPLOY_ENV === 'prodtest'
    ? (url: string) => {
        const options = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ url }),
        };

        return fetch('/api/imgErr', options);
      }
    : noop;
